/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Leveling_Imports_WriteInputs */



/**
* | output |
* | --- |
* | "Import levels and transfer from another bot" |
*
* @param {Perm_Product_Leveling_Imports_WriteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_leveling_imports_write = /** @type {((inputs?: Perm_Product_Leveling_Imports_WriteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Leveling_Imports_WriteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импортировать уровни и переносить их из другого бота")
	return /** @type {LocalizedString} */ ("Import levels and transfer from another bot")
});